import FaIcon, { faClock, faTruck } from '@/components/icon/FaIcon/FaIcon';
import ImageView from '@/components/ui/ImageView/ImageView';
import ScrollFade from '@/components/ui/ScrollFade/ScrollFade';
import { estimatedShippingDateText, eventStatusLabel, showEstimatedShippingDate } from '@/features/lottery/utils';
import { Format } from '@/lib/dateFns';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { formatDateCommon } from '@/utils/formatters';
import Link from 'next/link';
import type { LotteryEvent } from '../../types';
import styles from './LotteryEventList.module.scss';

function LotteryEventList({
  lotteryEventList,
}: {
  lotteryEventList: Array<LotteryEvent>;
}) {
  return (
    <ul className={styles.componentStyle}>
      {lotteryEventList.map((event) => (
        <ScrollFade key={event.id} tag='li'>
          <Link href={`/lotteries/${event.id}`} className={styles.itemBlock} prefetch={false}>
            <div className={styles.imageWrapper}>
              <ImageView src={event.subImageUrl} />
              <div className={styles.itemStatus}>
                <img src={eventStatusLabel(event.status)} alt='' />
              </div>
            </div>
            <div className={`${styles.itemName} ${utilsStyles.textBold}`}>{event.name}</div>
            {event.endAt && (
              <div className={styles.itemDate}>
                <FaIcon icon={faClock} />
                &nbsp;{formatDateCommon(event.endAt, Format.dateTimeLotteryJa)}
                &nbsp;まで
              </div>
            )}
            {showEstimatedShippingDate(event.endAt, event.estimatedShippingDate) && (
              <div className={styles.estimatedDeliveryDate}>
                <FaIcon icon={faTruck}></FaIcon>
                &nbsp;
                {estimatedShippingDateText({
                  eventEndAt: event.endAt,
                  estimatedShippingDate: event.estimatedShippingDate || undefined,
                })}
              </div>
            )}
          </Link>
        </ScrollFade>
      ))}
      {/* ダミー */}
      {dummy()}
    </ul>
  );
}

function dummy() {
  const result = [];
  for (let i = 0; i < 4; i++) {
    result.push(
      <li className={styles.dummy} key={`dummy_${i}`}>
        <div className={styles.dummyBlock}></div>
      </li>,
    );
  }
  return result;
}

export default LotteryEventList;
